import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import EN from '../../EN.json';
import FR from '../../FR.json';

import {
  getContentfulData,
  contentfulTranslationsConfig,
  getData
} from '../contentful';

import { useLocaleContext } from './LocaleContext';
import { useTranslationsContext } from './TranslationsContext';
import { localeEn } from '../misc';

const LocalizedStringsContext = createContext();

export const useLocalizedStringsContext = () =>
  useContext(LocalizedStringsContext);

const LocalizedStringsContextProvider = ({ children }) => {
  const [localizedStrings, setLocalizedStrings] = useState(EN);
  const [translations, setTranslations] = useState(null);

  const locale = useLocaleContext();

  useEffect(() => {
    setLocalizedStrings(locale === localeEn ? EN : FR);
    getContentfulData({ ...contentfulTranslationsConfig, locale }, false).then(
      res => {
        const { translations: localeTranslations } = getData(res);
        setTranslations(localeTranslations);
      }
    );
  }, [locale]);
  if(!translations) return null;
  return (
    <LocalizedStringsContext.Provider value={translations}>
      {children}
    </LocalizedStringsContext.Provider>
  );
};

LocalizedStringsContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default LocalizedStringsContextProvider;
